import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#0D47A1', // Deep Blue
      light: '#2196F3',
      dark: '#002171',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#D32F2F', // Bold Red
      light: '#FF6659',
      dark: '#9A0007',
      contrastText: '#FFFFFF',
    },
    background: {
      default: '#FFFFFF',
      paper: '#F5F5F5',
    },
    text: {
      primary: '#000000',
      secondary: '#424242',
    },
  },
  typography: {
    fontFamily: '"Rubik", "Helvetica", "Arial", sans-serif',
    h1: {
      fontFamily: '"Bebas Neue", "Helvetica", sans-serif',
      fontWeight: 400,
      fontSize: '5rem',
      letterSpacing: '0.05em',
      lineHeight: 1.1,
    },
    h2: {
      fontFamily: '"Bebas Neue", "Helvetica", sans-serif',
      fontWeight: 400,
      fontSize: '3.5rem',
      letterSpacing: '0.04em',
      lineHeight: 1.2,
    },
    h3: {
      fontFamily: '"Oswald", "Helvetica", sans-serif',
      fontWeight: 600,
      fontSize: '2.5rem',
      letterSpacing: '0.02em',
      lineHeight: 1.3,
    },
    h4: {
      fontFamily: '"Oswald", "Helvetica", sans-serif',
      fontWeight: 600,
      fontSize: '2rem',
      letterSpacing: '0.02em',
    },
    h5: {
      fontFamily: '"Oswald", "Helvetica", sans-serif',
      fontWeight: 500,
      fontSize: '1.5rem',
      letterSpacing: '0.01em',
    },
    h6: {
      fontFamily: '"Oswald", "Helvetica", sans-serif',
      fontWeight: 500,
      fontSize: '1.25rem',
      letterSpacing: '0.01em',
    },
    body1: {
      fontSize: '1rem',
      lineHeight: 1.7,
      fontWeight: 400,
    },
    body2: {
      fontSize: '0.875rem',
      lineHeight: 1.6,
      fontWeight: 400,
    },
    button: {
      fontFamily: '"Oswald", "Helvetica", sans-serif',
      fontWeight: 600,
      letterSpacing: '0.08em',
      textTransform: 'uppercase',
    },
  },
  shape: {
    borderRadius: 0,
  },
  shadows: [
    'none',
    '0 2px 4px rgba(0,0,0,0.1)',
    '0 4px 8px rgba(0,0,0,0.15)',
    '0 8px 16px rgba(0,0,0,0.2)',
    '0 12px 24px rgba(0,0,0,0.25)',
    '0 16px 32px rgba(0,0,0,0.3)',
    ...Array(19).fill('0 20px 40px rgba(0,0,0,0.35)'),
  ],
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 0,
          padding: '12px 32px',
          fontSize: '1rem',
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        },
      },
    },
  },
});

export default theme;